<template>
  <v-btn color="primary" @click="$emit('click')" v-bind="$attrs" :loading="loading">
    <v-icon left>mdi-content-save</v-icon>
    {{ activeLabel }}
  </v-btn>
</template>

<script>
export default {
  name: 'SaveButton',
  props: ['label', 'loading'],
  computed: {
    activeLabel () {
      if (this.label) {
        return this.label;
      } else {
        return this.$t('general.save');
      }
    }
  }
}
</script>
